<template>
    <button class="btn btn-block px-1 shadow-sm">
        <span class="text-center">
            <img :src="`/images/icons/${icon}.svg`" class="mx-auto d-block mt-1" alt="">
            <small><slot></slot></small>
        </span>
    </button>
</template>

<script>
export default {
    name: "SquareBtn",
    props: ['icon']
}
</script>

<style scoped>

</style>
